import { ToastRestaurant } from '@Types/toast';

export function getToastRestaurantLocationName(
  restaurant: ToastRestaurant | null | undefined,
): string | null {
  return restaurant?.general?.locationName || restaurant?.general?.name || null;
}
